module.exports = "/shifts/components/shiftsTipsComponent-ab5e4a.html";